import { backgroundTypeEnum } from 'common/utils/enums';
import AuthAsideLayout from 'layouts/auth-aside';
import { useRef } from 'react';

const AuthMainLayout = ({ 
  children, 
  asideChild,
  backgroundType = backgroundTypeEnum.BACKGROUND_LIGHT,
  bgColor,
  logo = '',
  bgImage,
}) => {

  const targetRef = useRef(null);

  const scrollToTarget = () => {
    targetRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  return (
    <main className='h-screen w-screen mobile:h-auto flex flex-col gap-4 md:grid md:grid-cols-[2fr_3fr] overflow-hidden'>
      {/* aside */}
      <AuthAsideLayout 
        onClick={scrollToTarget}
        backgroundType = {backgroundType}
        bgColor = {bgColor}
        logo = {logo}
        bgImage = {bgImage}
      >
        {asideChild}
      </AuthAsideLayout>      


      {/* <div className='flex md:hidden items-start m-8 px-6 w-full max-w-lg place-self-center'>
        <LogoImage dark={true} size='s'/>
      </div> */}

      {/* main section */}
      <div ref={targetRef} className='h-full relative flex flex-col items-center overflow-scroll py-8 md:px-8 md:py-16 max-w-md md:max-w-xl place-self-center min-h-screen'>    
        {children}
      </div>
    </main>
  );
};

export default AuthMainLayout;
